var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7239_17952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71429 0C2.56495 0 0 2.56495 0 5.71429V18.2857C0 21.435 2.56495 24 5.71429 24H18.2857C21.435 24 24 21.435 24 18.2857V5.71429C24 2.56495 21.435 0 18.2857 0H5.71429ZM5.14286 6.85714H18.8571C18.96 6.85714 19.057 6.86875 19.1484 6.89732L13.5313 12.5089C12.6855 13.3546 11.3089 13.3546 10.4632 12.5089L4.85156 6.89732C4.94299 6.86875 5.04 6.85714 5.14286 6.85714ZM4.04018 7.70871L8.33705 12L4.04018 16.2913C4.01161 16.1999 4 16.1029 4 16V8C4 7.89714 4.01161 7.80013 4.04018 7.70871ZM19.9598 7.70871C19.9884 7.80013 20 7.89714 20 8V16C20 16.1029 19.9884 16.1999 19.9598 16.2913L15.6574 12L19.9598 7.70871ZM9.14286 12.8058L9.65179 13.3203C10.2975 13.966 11.1487 14.2857 11.9944 14.2857C12.8458 14.2857 13.6913 13.966 14.3371 13.3203L14.8516 12.8058L19.1484 17.1027C19.057 17.1313 18.96 17.1429 18.8571 17.1429H5.14286C5.04 17.1429 4.94299 17.1313 4.85156 17.1027L9.14286 12.8058Z",
    fill: "#B0B5BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7239_17952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3a7e38def3a588c2bc68aa6f8d14fd93.svg";
export { ForwardRef as ReactComponent };